import React from 'react'
import { T } from 'components/Translations'
import { checkboxType } from 'common/types'

import StyledCheckbox, { CheckboxCustom } from './StyledCheckbox'

const Checkbox = ({ name, className, text, label, ...rest }) => {
  const id = `Checkbox-${name}`
  text = label ? <T label={label} /> : text

  return (
    <StyledCheckbox className={className}>
      <input type="checkbox" name={name} id={id} {...rest} />

      <CheckboxCustom>
        <svg viewBox="0 0 13.308 9.62" className="checkmark">
          <title>checkmark-thick</title>
          <path
            stroke="white"
            fill="#320856"
            strokeWidth="2"
            d="M12.92.419A1.386,1.386,0,0,0,10.94.412L5.287,6.225,2.37,3.246a1.361,1.361,0,0,0-.949-.421,1.27,1.27,0,0,0-.936.334l-.1.093A1.413,1.413,0,0,0,.4,5.206L4.3,9.194a1.366,1.366,0,0,0,.959.426h.036A1.327,1.327,0,0,0,6.2,9.275L12.92,2.364A1.413,1.413,0,0,0,12.92.419Z"
          />
        </svg>
      </CheckboxCustom>

      {text && <label htmlFor={id}>{text}</label>}
      {rest.children}
    </StyledCheckbox>
  )
}

Checkbox.propTypes = checkboxType

Checkbox.defaultProps = {
  required: false,
}

export default Checkbox
